import React from 'react';
import { CallTrendChart as _Unused } from './';
import { TrendChart } from '../trend-analytics/components/TrendChart';

// Thin wrapper to re-use existing TrendChart component
export const CallTrendChart = ({ data, title, height }) => {
  return (
    <TrendChart data={data} title={title} height={height} />
  );
};
